
<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Banner">
  <div class="image-text">
    <p>People Behind the Vision</p>
  </div>
</div>

<div class="bg-white" style="height: 10vh;"></div>

<app-people-behind-vision></app-people-behind-vision>
